/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState } from 'react';
import { View, Text, ScrollView } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';
import moment from 'moment';

import { scale, width } from '@components/frame';
import { navigateBack, Alert, isWeb, getStateParams } from '@helpers';

import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';

import Line from '@components/common/line';
import LineButton from '@components/common/lineButton';
import AnimatedHeader, { getHeight } from '@components/common/AnimatedHeader';
import Loading from '@components/loading';
import EditTool from '@components/tool/components/editTool';

import { getToolById, edit, remove } from '@reducers/tools';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const ToolsDetails = (props) => {
  const { C, getToolById, tools = [], route, edit, remove } = props;

  const headerHeight = getHeight();

  const [showEdit, setShowEdit] = useState(false);
  const [editConfig, setEditConfig] = useState({});

  const toogleEdit = () => {
    setShowEdit(!showEdit);
  };

  const id = getStateParams(route).id;

  const currentTool = tools.find((d) => d.toolId === id);

  const [tool, setTool] = useState(currentTool || {});
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    (async () => {
      if (!tool?.toolId) {
        const tool = await getToolById(id);
        setTool(tool?.searchResult?.[0]);
      }
    })();
  }, []);

  const triggerDelete = async (data) => {
    Alert({
      title: i18n.t('Are you sure?'),
      actions: [
        {
          text: i18n.t('No'),
          onPress: () => {},
          style: 'primary',
        },
        {
          text: i18n.t('Yes'),
          onPress: async () => {
            await deleteFN();
          },
        },
      ],
    });
  };

  const deleteFN = async () => {
    setDeleting(true);
    const result = await remove({
      toolId: tool.toolId,
    });
    if (result) {
      navigateBack();
    }
    setDeleting(false);
  };

  const toolDetails = [
    {
      value: tool?.description,
      name: i18n.t('Description'),
      valueName: 'description',
    },
    {
      value: tool?.memo,
      name: i18n.t('Memo'),
      valueName: 'memo',
    },
    {
      value: `${tool?.stickoutUM / 1000} ${i18n.t('mm')}`,
      name: `${i18n.t('Stickout')}`,
      valueName: 'stickoutMM',
      keyboardType: 'number-pad',
    },
  ];

  const ncDetails = [
    {
      value: 5,
      name: i18n.t('NC Files'),
    },
  ];

  const shadowStyles = getBoxShadowStyle({ type: 'Field', C });

  return [
    <View key="ToolsDetails" style={{ height: '100%', width: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }}>
      <View style={{ width, height: '100%' }}>
        <AnimatedHeader
          {...{
            text: `${tool?.toolName || ''}`,
            C,
            animated: false,
            back: true,
            backgroundColor: isWeb ? 'Background/Light/Detail' : 'Background/Light/Panel',
            borderBottomWidth: 0,
          }}
        />
        {tool?.toolId ? (
          <ScrollView contentContainerStyle={{ width: '100%', height: '100%', alignItems: 'center' }}>
            <View
              style={{
                width: '100%',
                maxWidth: scale(720),
                marginTop: scale(30) + headerHeight,
                paddingHorizontal: scale(15),
              }}
            >
              <View style={[shadowStyles, { borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
                {toolDetails.map((item, index) => (
                  <Line
                    {...{
                      item: {
                        ...item,
                        onClick: () => {
                          setEditConfig({
                            header: item.name,
                            initData: {
                              [item.valueName]: String(tool[item.valueName]),
                            },
                            inputs: [
                              {
                                key: item.valueName,
                                isLable: false,
                                noArrow: true,
                                placeholder: item.name,
                                keyboardType: item.keyboardType,
                              },
                            ],
                          });
                          toogleEdit();
                        },
                      },
                      index,
                      array: toolDetails,
                      C,
                      roundTop: index === 0,
                      roundBottom: toolDetails.length - 1 === index,
                    }}
                    key={item.valueName}
                  />
                ))}
              </View>
              <View style={{ marginTop: scale(28), marginLeft: scale(15) }}>
                <Text
                  style={[
                    {
                      color: C('Label/Light/Tertiary'),
                    },
                    font.Footnote,
                  ]}
                >
                  {i18n.t('WHERE USED')}
                </Text>
              </View>
              <View style={[shadowStyles, { borderRadius: scale(SCREEN_BORDER_RADIUS), marginTop: scale(5) }]}>
                {ncDetails.map((item, index) => (
                  <Line
                    {...{
                      item,
                      index,
                      array: ncDetails,
                      C,
                      roundTop: index === 0,
                      roundBottom: ncDetails.length - 1 === index,
                    }}
                    key={item.name}
                  />
                ))}
              </View>
              <View style={{ marginTop: scale(30) }}>
                <LineButton
                  {...{
                    C,
                    onPress: () => {
                      if (deleting) {
                        return;
                      }
                      triggerDelete();
                    },
                    loading: deleting,
                    text: `${i18n.t('Delete')} ${tool.toolName}`,
                    color: 'Label / Light / Error',
                  }}
                />
              </View>
              <View style={{ marginTop: scale(6), marginHorizontal: scale(15) }}>
                <Text
                  style={[
                    {
                      color: C('Label/Light/Tertiary'),
                    },
                    font['Caption 1'],
                  ]}
                >
                  {i18n.t('Delete this tool and remove it from all NC Files in which is it used')}
                </Text>
              </View>
              <View style={{ marginTop: scale(26), marginHorizontal: scale(15) }}>
                <Text
                  style={[
                    {
                      color: C('Label/Light/Tertiary'),
                    },
                    font['Caption 1'],
                  ]}
                >
                  {i18n.t('Last modified on')} {moment(tool.lastModifiedOn).format('DD-MM-YYYY')} {i18n.t('by')} {tool.lastModifiedByUser}
                </Text>
                <Text
                  style={[
                    {
                      color: C('Label/Light/Tertiary'),
                    },
                    font['Caption 1'],
                  ]}
                >
                  {i18n.t('Created on')} {moment(tool.createdOn).format('DD-MM-YYYY')} {i18n.t('by')} {tool.createdByUser}
                </Text>
              </View>
            </View>
          </ScrollView>
        ) : (
          <Loading background={C('Background/Light/Detail')} />
        )}
      </View>
    </View>,
    <EditTool
      key="EditTool"
      {...{
        tool,
        showEdit,
        toogleEdit,
        edit,
        setTool,
        editConfig,
      }}
    />,
  ];
};

export default connect(({ tools: { tools, loaded } }) => ({ tools, loaded }), {
  getToolById,
  edit,
  remove,
})(ColorWrapper(ToolsDetails));
